<template>
  <section class="main">
    <div class="header">我的订单</div>
    <div class="orderlist">
      <div class="orderbox">
        <div class="orderno">订单编号：{{orderInfo.order_no}}</div>
        <div class="orderTiime">下单时间：{{orderInfo.create_time | formateTime}}</div>
        <div class="time" v-show="orderInfo.pay_status == 2">付款时间：{{orderInfo.pay_time}}</div>
        <div class="state">状态：{{orderInfo.pay_status|orderStateName}}</div>
      </div>
      <div class="ohead">
        <div class="d1">课程名称</div>
        <div class="d2">单价</div>
        <div class="d4">优惠减免</div>
        <div class="d3">实付款</div>
        <div class="d5">操作</div>
      </div>
      <div class="item" v-for="item in orderInfo.items" v-bind:key="'goods'+item.id">
        <div class="content">
          <div class="d1" @click="goGoodDetail(item.goods_id,item.goods_type)">
            <div class="title-box">
              <img :src="'/imgs/'+item.goods_img" alt />
              <p class="title">{{item.goods_name}}</p>
            </div>
          </div>
          <div class="d2">
            <div class="price-box">
              <span class="price">￥{{item.goods_amount | formatMoney}}</span>
            </div>
          </div>
          <div class="d4">
            <div class="state-box">
              优惠券省-￥{{orderInfo.deduction| formatMoney}}
              <br />
              <br />
              余额抵扣-￥{{orderInfo.balance_pay | formatMoney}}
              <br />
            </div>
          </div>
          <div class="d3">
            <div class="price-box">
              <span class="price">￥{{(orderInfo.amount - orderInfo.deduction-orderInfo.balance_pay) | formatMoney}}</span>
            </div>
          </div>

          <div class="d5">
            <div class="tools">
              <a style="background:red;" href="javascript:void(0)" @click="goPay(orderInfo.id)" v-show="orderInfo.pay_status == 0">去支付</a>
              <a
                v-show="orderInfo.pay_status == 0"
                href="javascript:void(0)"
                @click="cancelOrderFun(orderInfo.id)"
              >取消订单</a>
              <span
                v-show="orderInfo.pay_status == 1 || orderInfo.pay_status == 2"
                class="iconfont icon-locationfuzhi"
              ></span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import "@/styles/userIndex.scss";
import { cancelOrder, orderDetail } from "@/api/order.js";

export default {
  props: {
    id: Number //订单id,其他页面传递过来
  },
  data() {
    return { 
      orderInfo: {}, //订单详情
    };
  },
  mounted() {
    this.loadData();
  },
  filters: {
    orderStateName: function(value) {
      switch (value) {
        case 0:
          return "未支付";
        case 1:
          return "已取消";
        case 2:
          return "已支付";
      }
    },
    formateTime: function(value) {
      if (value == undefined) {
        return;
      }
      let date = new Date(value * 1000);
      let y = date.getFullYear();
      let MM = date.getMonth() + 1;
      MM = MM < 10 ? "0" + MM : MM;
      let d = date.getDate();
      d = d < 10 ? "0" + d : d;
      let h = date.getHours();
      h = h < 10 ? "0" + h : h;
      let m = date.getMinutes();
      m = m < 10 ? "0" + m : m;
      let s = date.getSeconds();
      s = s < 10 ? "0" + s : s;
      return y + "." + MM + "." + d + " " + h + ":" + m + ":" + s;
    }
  },
  methods: {
    loadData: function() {
      if(this.id >  0){
        orderDetail(this.id).then(resp => {
          if (resp != -1) {
            this.orderInfo = resp;
          }
        });
      }else{
        this.$message({
          message: '订单id不能为空!',
          type: 'error'
        });
      }
    },
    //取消订单
    cancelOrderFun: function(order_id) {
      if (confirm("确定要取消订单吗?")) {
        cancelOrder(order_id).then(resp => {
          if (resp != -1) {
            this.$message({
              message: resp,
              type: "success"
            });
            this.loadData();
          }
        });
      }
    },
    goGoodDetail: function(goods_id, goods_type) {
      if (goods_type == 1) {
        //课程
        this.$router.push(`/course/` + goods_id);
      } else if (goods_type == 2) {
        //课程包
        this.$router.push(`/coursePkg/` + goods_id);
      }
    },
    //调起支付
    goPay:function(id){
      this.$router.push("/user/orderPay/"+id);
    }
  },
  components: {}
};
</script>
<style lang="scss" scoped>
body {
  background: #efefef;
}
.orderlist {
  .d1 {
    width: 45%;
    text-align: center;
  }
  .d2 {
    width: 12%;
    text-align: center;
  }
  .d3 {
    width: 12%;
    text-align: center;
  }
  .d4 {
    width: 12%;
    text-align: center;
  }
  .d5 {
    width: 19%;
    text-align: center;
  }
  .ohead {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-content: center;
    margin: 30px 20px 0 20px;
    height: 40px;
    line-height: 40px;
    background: #e8f0fb;
    div {
      font-size: 1.4em;
      color: #3a3a3a;
    }
  }
  .orderbox {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    height: 40px;
    line-height: 40px;
    padding: 0 20px;
    div {
      font-size: 1.4em;
      color: #7a7a7a;
    }
    .state {
      color: #ff0000;
    }
  }

  .item {
    padding: 0 20px;

    .content {
      background: #dcdcdc;
      border: 1px solid #dcdcdc;
      border-top: 0;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      .title-box {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        background: #f9f9f9;
        overflow: hidden;
        border-bottom: 1px solid #dcdcdc;
        padding: 10px;cursor: pointer;
        img {
          height: 90px;
          width: 160px;
          background: #efefef;
          display: block;
          padding: 10px;
        }
        .title {
          color: #504f4f;
          font-size: 1.4em;
          padding: 10px;
        }
      }
      .title-box:last-child {
        border-bottom: 0;
      }
      .price-box {
        background: #f9f9f9;
        border-left: 1px solid #dcdcdc;
        display: flex;
        flex-direction: column;
        align-content: center;
        justify-content: center;
        text-align: center;
        height: 100%;
        .price {
          color: #504f4f;
          font-size: 1.4em;
        }
      }
      .state-box {
        height: 100%;
        background: #f9f9f9;
        border-left: 1px solid #dcdcdc;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-content: center;
        text-align: center;
        .state {
          font-size: 1.4em;
          color: #585757;
          margin-bottom: 10px;
        }
        a {
          color: #313131;
          font-size: 1.4em;
        }
      }
      .tools {
        display: flex;
        text-align: center;
        flex-direction: column;
        border-left: 1px solid #dcdcdc;
        justify-content: center;
        height: 100%;
        background: #f9f9f9;
        a {
          padding: 5px 10px;
          background: #b5b4b5;
          border-radius: 15px;
          color: white;
          text-align: center;
          display: block;
          width: 60px;
          margin: 5px auto;
        }
      }
    }
  }
}
</style>